export default __webpack_public_path__ + "3739af1aa26b437d377462dcf6f1643f.png";